<template>
  <div class="edit-dialog" @contextmenu.stop>
    <el-dialog
      title="设置付费规则"
      width="500px"
      height="521px"
      top="calc( 50vh - 150px )"
      custom-class="edit-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="setting-container">
        <div class="setting-item">
          <span>销售定价：</span>
          <div class="price-setting">
            <div class="price-item">
              <span>单期：</span>
              <el-input v-model="price" type="number" size="mini"></el-input>
              <span>元/期</span>
            </div>
            <div class="price-item">
              <span class="tip">按期付费</span>
              <el-tooltip placement="right" effect="light" content="按期付费：可永久阅读付过费的报纸。">
                <div class="tooltips">?</div>
              </el-tooltip>
              <div class="price-item-checkbox">
                <el-checkbox-group v-model="issueDateList">
                  <el-checkbox label="mPrice"></el-checkbox>
                  <span>月度:</span><el-input v-model="issuePrice.mPrice" type="number" size="mini" :disabled="!issueDateList.includes('mPrice')"></el-input>
                  <span style="margin-right: 35px">元/月</span>
                  <el-checkbox label="qPrice"></el-checkbox>
                  <span>季度:</span><el-input v-model="issuePrice.qPrice" type="number" size="mini" :disabled="!issueDateList.includes('qPrice')"></el-input><span>元/季</span>
                  <el-checkbox label="hPrice"></el-checkbox>
                  <span>半年:</span><el-input v-model="issuePrice.hPrice" type="number" size="mini" :disabled="!issueDateList.includes('hPrice')"></el-input>
                  <span style="margin-right: 22px">元/半年</span>
                  <el-checkbox label="yPrice"></el-checkbox>
                  <span>年度:</span><el-input v-model="issuePrice.yPrice" type="number" size="mini" :disabled="!issueDateList.includes('yPrice')"></el-input><span>元/年</span>
                </el-checkbox-group>
              </div>
            </div>
            <!-- <div class="price-item">
              <span class="tip">会员授权</span>
              <el-tooltip placement="right" effect="light" content="会员授权：会员期限内可以阅读所有报纸。">
                <div class="tooltips">?</div>
              </el-tooltip>
              <div class="price-item-checkbox">
                <el-checkbox label="月度："></el-checkbox>
                <el-input v-model="price" type="number" size="mini"></el-input><span>元/月</span>
                <el-checkbox label="季度："></el-checkbox>
                <el-input v-model="price" type="number" size="mini"></el-input><span>元/季</span>
                <el-checkbox label="半年："></el-checkbox>
                <el-input v-model="price" type="number" size="mini"></el-input><span style="margin-right: 30px">元/半年</span>
                <el-checkbox label="年度："></el-checkbox>
                <el-input v-model="price" type="number" size="mini"></el-input><span>元/年</span>
              </div>
            </div>-->
          </div>
        </div>
        <div class="setting-item limit-item">
          <span>试读范围：</span>
          <div>
            <div>
              <span>最近</span>
              <el-input v-model="trialIssue" type="number" size="mini"></el-input><span style="margin-right: 20px">期</span>
              <el-radio v-model="chargePageOption" :label="0"><span>全部版次</span></el-radio>
              <el-radio v-model="chargePageOption" :label="1">
                <span>前</span><el-input v-model="chargePage" :disabled="chargePageOption === 0" type="number" size="mini"></el-input> <span>版</span>
              </el-radio>
            </div>
            <div>
              <el-checkbox v-model="trialOption"></el-checkbox>
              <span>文章内容前</span>
              <el-input v-model="trialPercent" :disabled="!trialOption" type="number" size="mini"></el-input>
              <span>%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item left" @click="saveThen()">保存</div>
        <div class="edit-footer-item right" @click="handleCancel()">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import compareVipRight from '@components/common/compareVipRight.js'
import chargeApi from '@api/chargeManager'

export default {
  name: 'BaozhiPrice',
  mixins: [compareVipRight],
  data() {
    return {
      dialogVisible: false,
      id: '',
      price: '',
      trialPercent: null,
      issueDateList: [],
      chargePage: null,
      isIndividual: 0,
      trialIssue: null,
      issuePrice: {},
      chargePageOption: -1,
      trialOption: false
    }
  },
  props: {
    workObj: Object
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.initSetting()
      }
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    saveThen() {
      if (!this.price || this.price <= 0 || this.price > 9999.99) {
        this.$message({
          message: '请设置单期报纸定价,输入0-9999.99的数字',
          type: 'error'
        })
        return
      }
      if (this.trialIssue === null || this.trialIssue === '' || this.trialIssue < 0 || this.trialIssue % 1 !== 0 || this.trialIssue > 366) {
        this.$message({
          message: '请设置试读期数，输入0-366的整数',
          type: 'error'
        })
        return
      }
      if ((this.chargePage === null || this.chargePage < 0 || this.chargePage % 1 !== 0) && this.chargePageOption === 1) {
        this.$message({
          message: '请设置试读范围，输入0-9999的整数',
          type: 'error'
        })
        return
      }
      if (this.trialOption && (!this.trialPercent || this.trialPercent < 0 || this.trialPercent > 100)) {
        this.$message({
          message: '请设置文章试读范围，输入0-100的整数',
          type: 'error'
        })
        return
      }
      if (
        (this.issueDateList.includes('mPrice') && (!this.issuePrice.mPrice || this.issuePrice.mPrice <= 0 || this.issuePrice.mPrice > 9999.99)) ||
        (this.issueDateList.includes('qPrice') && (!this.issuePrice.qPrice || this.issuePrice.qPrice <= 0 || this.issuePrice.qPrice > 9999.99)) ||
        (this.issueDateList.includes('hPrice') && (!this.issuePrice.hPrice || this.issuePrice.hPrice <= 0 || this.issuePrice.hPrice > 9999.99)) ||
        (this.issueDateList.includes('yPrice') && (!this.issuePrice.yPrice || this.issuePrice.yPrice <= 0 || this.issuePrice.yPrice > 9999.99))
      ) {
        this.$message({
          message: '请设置按期定价,输入0-9999.99的数字',
          type: 'error'
        })
        return
      }
      const issuePrice = this.issueDateList.reduce((acc, key) => {
        acc[key] = this.issuePrice[key]
        return acc
      }, {})
      let param = {
        id: this.id,
        price: this.price,
        trialIssue: this.trialIssue,
        issuePrice: JSON.stringify(issuePrice),
        trialPercent: this.trialPercent,
        trialOption: this.trialOption ? 1 : 0,
        chargePage: this.chargePageOption === 0 ? -1 : this.chargePage
      }
      chargeApi.setCharge(param).then((res) => {
        if (res.data && res.data.status === 0) {
          this.dialogVisible = false
          this.$emit('saveSuccess', 'cloud_read_baozhi')
        } else {
          this.$message({
            message: res.data.message || '保存失败',
            type: 'error'
          })
        }
      })
    },
    initSetting() {
      this.id = this.workObj.id
      this.price = this.workObj.price
      if (this.workObj.chargePage === -1) {
        this.chargePageOption = 0
        this.chargePage = null
      } else {
        this.chargePageOption = 1
        this.chargePage = this.workObj.chargePage
      }
      this.issueDateList = []
      this.issuePrice = this.workObj.issuePrice ? JSON.parse(this.workObj.issuePrice) : {}
      for (const issuePriceKey in this.issuePrice) {
        this.issueDateList.push(issuePriceKey)
      }
      this.trialIssue = this.workObj.trialIssue
      this.trialPercent = this.workObj.trialPercent
      this.trialOption = this.workObj.trialOption === 1
    }
  }
}
</script>
<style lang="scss" scoped>
.setting-container {
  .setting-item {
    margin-bottom: 10px;
    font-size: 12px;
    display: flex;
    align-items: baseline;
    .el-input {
      display: inline-block;
      width: 40px;
      margin-right: 10px;
    }
    span {
      margin-right: 10px;
    }
    .tip {
      color: #808080;
    }
    .tooltips {
      width: 16px;
      height: 16px;
      background-color: #df5813;
      border-radius: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 16px;
      display: inline-block;
    }
    .price-setting {
      width: 350px;
    }
    .el-checkbox {
      margin-right: 8px;
    }
    .price-item {
      margin-bottom: 10px;
      .price-item-checkbox {
        margin-top: 10px;
        span {
          font-size: 12px !important;
        }
        .el-input {
          margin-bottom: 5px;
        }
      }
      .el-input {
        width: 50px;
      }
    }
    .el-radio {
      margin-right: 10px;
    }
  }
}
.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-left: 30px;
    }
  }
}
</style>
<style lang="scss">
.price-item {
  .price-item-checkbox {
    .el-checkbox-group {
      .el-checkbox {
        .el-checkbox__label {
          display: none;
        }
      }
    }
  }
}
.limit-item {
  .el-radio {
    .el-radio__label {
      font-size: 12px;
    }
  }
}
</style>
